import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { QRCode } from "react-qrcode-logo";

import { Button } from "@mui/material";

//import { useKioskHorizontalStyles } from "./../../../../kioskstyles";
import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";
import SubtitleWrapper from "./../../Components/Shared/PanelElements/SubtitleWrapper";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";

import "react-phone-number-input/style.css";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

let env = require("./../../../../env");

// props has activeStep
export default function CharityElement({
  imgPath,
  Title,
  Description,
  CharityId,
  setSelectedCharity
}) {
  const {} = useContext(KioskContext);

  const { qrCode, getKioskTheme } = useContext(SocketIOContext);

  //const altText = Title + " Logo";

  const kiosktheme = getKioskTheme();
  const kioskstyles = useKioskVerticalStyles();
  const [hasError, setHasError] = useState(false);

  const fallbackImagePath =
    env.REACT_APP_API_ENDPOINT +
    "/kiosk/getImage/CharityFallback" +
    "?t=" +
    kiosktheme.lastUpdatedImgETag;

  return (
    <>
      <div
        style={kioskstyles.charities.charityElement}
        onClick={() => {
          console.log("[DEBUG] setSelectedCharity", setSelectedCharity);
          setSelectedCharity({
            Title: Title,
            Description: Description,
            id: CharityId
          });
        }}
      >
        {hasError && (
          <>
            <VolunteerActivismIcon
              sx={kioskstyles.charities.charityElementDefaultLogoIcon}
            />
          </>
        )}
        {!hasError && (
          <>
            <img
              src={imgPath}
              // onLoad={() => setLoading(false)}
              style={kioskstyles.charities.charityElementLogo}
              alt={Title + " Logo"}
              onError={e => {
                setHasError(true);
                // if (e.target.src !== fallbackImagePath) {
                //   e.target.src = fallbackImagePath;
                // }
              }}
            ></img>
          </>
        )}

        <div style={kioskstyles.charities.charityElementTitle}>{Title}</div>
        {/* <div style={kioskstyles.charities.charityElementDescription}>
          {Description}
        </div> */}
        {/* <Button
          variant="outlined"
          sx={kioskstyles.charities.charityElementButton}
        >
          <Translate value="application.theme.charityDonateNow" />
        </Button> */}
      </div>
    </>
  );
}
